
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.164 13.594v-1.04h9.625v1.04H3.164zm5.344-6.578v4.5H7.422v-4.5H3.164v-1.04h4.258v-4.5h1.086v4.5h4.273v1.04H8.508z","fill":"#748190"}})])
          )
        }
      }
    